import LottieControl from "@src/components/lottie"
import React from "react"

import loadingJson from "@images/lottieJson/loading.json"
import * as styles from "./prepare.module.scss"
import classnames from "@src/utils/classnames"

const Prepare = () => (
  <div className={classnames(styles.loadingContainer)}>
    <div className={styles.loadingBox}>
      <LottieControl animationData={loadingJson} className={styles.loading} />
      <p>更多资讯即将开放，敬请期待</p>
    </div>
  </div>
)

export default Prepare
